import Environment from '../../../Environment';
import BaseService, { IHttpResponse, IUri, buildUrl } from '../../BaseService';
import { IGroup } from '../Types';

const RESOURCE = 'group';

interface IUpdateGroup extends Omit<IUri, 'resource'> {
  id: string;
  body: Partial<IGroup>;
  token: string;
}

interface IUpdateGroupResponse extends IHttpResponse {
  body?: IGroup;
}

export default ({
  id,
  body,
  token,
}: IUpdateGroup): Promise<IUpdateGroupResponse> => {
  const url = buildUrl({
    host: Environment.groupsHost,
    resource: RESOURCE,
    id,
  });

  return BaseService.Patch({ url, token, data: body });
};
